import TemplateSliderEditing from './template-slider-editing';
import TemplateSliderUI from './template-slider-ui';
import { Plugin } from '@ckeditor/ckeditor5-core';
import './styles.css';
export default class TemplateSlider extends Plugin {
    static get requires() {
        return [TemplateSliderEditing, TemplateSliderUI];
    }
}
